import { getFontStyles } from '../helper';
const getFontData = (props, kind) => {
    const { theme, size, } = props;
    const fonts = getFontStyles({ theme, size, kind });
    return Object.assign({}, fonts);
};
export default getFontData;
